import { useEffect, useMemo, useState } from "react";

import Joi from "joi-browser";
import Form from "V2.0/components/Form";

import { Button } from "V2.0/common/button";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import { Heading } from "V2.0/common/heading";
import mcube from "V2.0/images/mcube.png";

const buttonInfoTwilio = {
  label: "Connect MCube",
  style: "entire-width",
};

const template = [
  {
    name: "callCreationUrl",
    type: "text",
    label: "Call Creation URL",
  },
  {
    name: "callEndUrl",
    type: "text",
    label: "Call End URL",
  },
  {
    name: "authToken",
    type: "text",
    label: "Auth Token",
  },
  {
    name: "phoneNumbers",
    label: "Phone Numbers (EXE)",
    type: "inputFieldList",
    addLabel: "+ Add Phone Number",
    addPlaceholder: "",
  },
];

const schema = {
  callCreationUrl: Joi.string().required().label("Call Creation URL"),
  callEndUrl: Joi.string().required().label("Call End URL"),
  authToken: Joi.string().required().label("Auth Token"),
  phoneNumbers: Joi.array()
    .items(Joi.string().regex(/^[a-zA-Z0-9+]+$/))
    .min(1)
    .required()
    .label("Phone Number"),
};

export default function MCubeForm(props) {
  const { mcubeSettings, workspaceId, updateMcubeSettings, isViewOnly } = props;

  const [inputField, setInputField] = useState({
    authToken: "",
    callCreationUrl: "",
    callEndUrl: "",
    phoneNumbers: [],
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setInputField({
      authToken: mcubeSettings.authToken,
      callCreationUrl: mcubeSettings.callCreationUrl,
      callEndUrl: mcubeSettings.callEndUrl,
      phoneNumbers: mcubeSettings.phoneNumbers,
    });
  }, [mcubeSettings]);

  async function handleSave(data) {
    const payload = {
      telephonySettings: {
        telephonyProvider: "mcube",
        mcubeSettings: data,
      },
    };

    const lifecycleCbs = {
      init: () => {
        setLoading(true);
        message.loading("Connecting Mcube");
      },
      success: () => {
        message.destroy();
        message.success("MCube Connected");
        setLoading(false);
      },
      error: (e) => {
        message.destroy();
        setLoading(false);
        showErrorToast(e, "Failed to connect MCube");
      },
    };

    updateMcubeSettings(payload, workspaceId, lifecycleCbs);
  }

  const updatedTemplate = useMemo(() => {
    if (!isViewOnly) {
      return template;
    }

    return template.map((field) => {
      return {
        ...field,
        disabled: isViewOnly,
      };
    });
  }, [isViewOnly]);

  const updatedButtonInfo = !isViewOnly ? buttonInfoTwilio : {};

  return (
    <div className="border rounded-lg p-8">
      <div className="flex gap-x-2">
        <img
          src={mcube}
          width={60}
        />
        <Heading>Connect MCUBE</Heading>
      </div>
      <Form
        key={JSON.stringify(inputField)}
        errorMessage={{}}
        inputField={inputField}
        template={updatedTemplate}
        schema={schema}
        buttonInfo={updatedButtonInfo}
        onSubmit={handleSave}
        loading={loading}
        setLoading={setLoading}
      />
    </div>
  );
}
